var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _vm.required
      ? _c("span", { staticClass: "text-danger" }, [_vm._v(" *")])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-control-plaintext pt-3" },
      [
        _c("switches", {
          attrs: {
            id: _vm.name,
            name: _vm.name,
            theme: "bootstrap",
            color: "danger",
            "type-bold": "true",
            disabled: !!_vm.disabled,
          },
          on: { input: _vm.onChange },
          model: {
            value: _vm.model[_vm.name],
            callback: function ($$v) {
              _vm.$set(_vm.model, _vm.name, $$v)
            },
            expression: "model[name]",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.errors[_vm.name]
      ? _c("small", {
          staticClass: "form-text text-danger",
          domProps: { textContent: _vm._s(_vm.errors[_vm.name][0]) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }